import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";

const GROUPS = [["individual", "People"], ["trust", "Trusts"], ["entity", "Entities"]];

export const HolderPick = ({ nodes, value, onChange }) => {
  const [open, setOpen] = useState(false);
  const cur = nodes.find((n) => n.id === value);
  const sorted = [...nodes].sort((a, b) => a.name.localeCompare(b.name));
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" aria-expanded={open} className="w-full justify-between rounded-sm bg-white font-normal" data-testid="org-search-input">
          <span className={`truncate ${cur ? "text-slate-900" : "text-slate-500"}`}>{cur ? cur.name : "Find an entity or person"}</span>
          <ChevronsUpDown className="h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[var(--radix-popover-trigger-width)] min-w-[18rem]" align="start">
        <Command>
          <CommandInput placeholder="Type to filter…" data-testid="org-search-filter" />
          <CommandList className="max-h-80">
            <CommandEmpty>No match.</CommandEmpty>
            {GROUPS.map(([k, label]) => {
              const items = sorted.filter((n) => (n.kind || "entity") === k);
              return items.length > 0 && (
                <CommandGroup key={k} heading={label}>
                  {items.map((n) => (
                    <CommandItem key={n.id} value={`${n.name} ${n.id}`} onSelect={() => { onChange(n.id); setOpen(false); }} data-testid={`org-search-result-${n.id}`}>
                      <Check className={`h-4 w-4 mr-2 ${n.id === value ? "opacity-100" : "opacity-0"}`} />
                      <span className="truncate">{n.name}</span>
                    </CommandItem>
                  ))}
                </CommandGroup>
              );
            })}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
